<div
	*ngIf="!is_header"
	class="steps-container"
	[class.multi-line]="steps.length > 3"
	[attr.data-element-view]="'step_display__' + location + '__[' + steps_display + ']'"
>
	<div *ngFor="let step of steps" class="arrow-container">
		<div class="arrow-step">
			<p class="step-text">
				{{ step.name }}
				<span *ngIf="step.minutes_to_complete" class="step-minutes-to-complete"><span>approx. </span>{{step.minutes_to_complete  | pluralise:'minute':'+s'}}</span>
			</p>

		</div>
	</div>
</div>

<div *ngIf="is_header" class="steps-container-outer">
	<div class="pre-steps"></div>
	<div class="steps-container header">
		<div
			*ngFor="let step of steps; index as idx"
			class="arrow-container"
			[ngClass]="{
				'colored-step': idx <= current_step_index,
				'normal-step': idx > current_step_index,
				'current-step': idx === current_step_index
			}"
			[attr.data-element-click]="'step_link__' + location + '__[' + step.name + ']'"
			(click)="stepClickHandler($event, idx)"
		>
			<p class="step-text">
				{{ step.name }}
				<span *ngIf="step.minutes_to_complete" class="step-minutes-to-complete"><span>approx. </span>{{step.minutes_to_complete | pluralise:'minute':'+s'}}</span>
			</p>
		</div>
	</div>
	<div class="post-steps"></div>
</div>
